"use client";

import { LogOut } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { isMsalConfigured } from "@/auth/msalConfig";

/** Renders logout menu item: MSAL logout when configured, else redirect to /api/auth/logout. */
export function LogoutMenuItem() {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const handleClick = async () => {
    if (isMsalConfigured) {
      try {
        await instance.logoutRedirect();
      } catch {
        window.location.href = "/api/auth/logout";
      }
    } else {
      window.location.href = "/api/auth/logout";
    }
  };

  return (
    <DropdownMenuItem className="gap-2 text-destructive" onClick={handleClick}>
      <LogOut className="h-3.5 w-3.5" /> {String(t("topbar.logout"))}
    </DropdownMenuItem>
  );
}
